































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { Route } from 'vue-router'
import { Dictionary } from 'vue-router/types/router'
import { Form as ElForm, Input } from 'element-ui'
import { UserModule } from '@/store/modules/user'
import { isPhone, isPassword } from '@/utils/validate'
import { getOtherQuery } from '@/utils/common'
import { sendCode } from '@/api/login'
import { checkNeedCaptcha } from '@/api/login'
import FingerprintJS from '@fingerprintjs/fingerprintjs'

const COUNT = 60

@Component({
  name: 'PhoneLogin'
})
export default class extends Vue {
  private loginForm = {
    phone: '',
    password: '',
    code: ''
  }

  private loginRules = {
    phone: [{ validator: this.validatePhone, trigger: 'change' }],
    password: [{ validator: this.validatePwd, trigger: 'change' }],
    code: [{ validator: this.validateCode, trigger: 'change' }]
  }

  private passwordType = 'password'
  private loading = false
  private redirect?: string
  private otherQuery: Dictionary<string> = {}
  private uuid?: string

  private loginMode: 'password' | 'code' | null = null

  private countdownSeconds = COUNT + 1
  private codeText = '获取验证码'
  private timer: NodeJS.Timeout | undefined

  private get isLoginValid() {
    if (this.loginMode === 'code') {
      return !!(this.loginForm.phone && this.loginForm.password && this.loginForm.code)
    }
    return !!(this.loginForm.phone && this.loginForm.password)
  }

  @Watch('$route', { immediate: true })
  private onRouteChange(route: Route) {
    const query = route.query as Dictionary<string>
    if (query) {
      this.redirect = query.redirect
      this.otherQuery = getOtherQuery(query)
    }
  }

  mounted() {
    FingerprintJS.load().then(fp => {
      fp.get().then(result => {
        const visitorId = result.visitorId
        this.uuid = visitorId
      })
    })
    if (this.loginForm.phone === '') {
      (this.$refs.phone as Input).focus()
    }
  }

  destroyed() {
    this.clearTimer()
  }

  private validatePhone(rule: any, value: string, callback: Function) {
    if (!isPhone(value)) {
      callback(new Error('请输入正确的手机号码'))
    } else {
      callback()
    }
  }

  private validatePwd(rule: any, value: string, callback: Function) {
    if (this.loginMode === 'password' && !isPassword(value)) {
      callback(new Error('8~16位数字和英文组成'))
    } else {
      callback()
    }
  }

  private validateCode(rule: any, value: string, callback: Function) {
    if (this.loginMode === 'code' && !value) {
      callback(new Error('请输入验证码'))
    } else {
      callback()
    }
  }

  private async onPhoneBlur() {
    (this.$refs.loginForm as ElForm).validateField('phone', async(error) => {
      if (error) return
      try {
        const res: any = await checkNeedCaptcha(this.loginForm.phone)
        // 假设返回 true 表示需要验证码
        this.loginMode = res.data ? 'code' : 'password'
        this.loginForm.code = ''
        this.resetCountdown()
        this.$nextTick(() => {
          if (this.loginMode === 'code') {
            const codeInput = this.$refs.code as Input | undefined
            if (codeInput && typeof (codeInput as any).focus === 'function') {
              codeInput.focus()
            }
          } else {
            const pwdInput = this.$refs.password as Input | undefined
            if (pwdInput && typeof (pwdInput as any).focus === 'function') {
              pwdInput.focus()
            }
          }
        })
      } catch (e) {
        // 如果检测接口失败，回退为密码登录
        this.loginMode = 'password'
      }
    })
  }

  private togglePwd() {
    this.passwordType = this.passwordType === 'password' ? '' : 'password'
    this.$nextTick(() => {
      (this.$refs.password as Input).focus()
    })
  }

  private async handleSubmit() {
    (this.$refs.loginForm as ElForm).validate(async(valid: boolean) => {
      if (!valid) return
      this.loading = true
      try {
        if (this.loginMode === 'code') {
          await UserModule.CodeLogin({ phone: this.loginForm.phone, code: this.loginForm.code })
        } else {
          const params: any = { phone: this.loginForm.phone, password: this.loginForm.password }
          if (this.uuid) params.uuid = this.uuid
          await UserModule.PasswordLogin(params)
        }
        this.$router.push({ path: this.redirect || '/', query: this.otherQuery })
        setTimeout(() => {
          this.loading = false
          this.$notify({ title: '登录成功', message: 'welcome！', type: 'success' })
        }, 400)
      } catch (e) {
        this.loading = false
      }
    })
  }

  private async getCode() {
    (this.$refs.loginForm as ElForm).validateField('phone', async(error) => {
      if (error) return
      await sendCode(this.loginForm.phone)
      this.$message.success('验证码发送成功，请注意查收')
      localStorage.setItem('surplus_time', `${new Date().getTime() + COUNT * 1000}`)
      this.startCountdown()
    })
  }

  private startCountdown() {
    this.countdownSeconds--
    this.codeText = `${this.countdownSeconds}s`
    this.timer = setInterval(() => {
      this.countdownSeconds--
      this.codeText = `${this.countdownSeconds}s`
      if (this.countdownSeconds <= 0) {
        this.resetCountdown()
      }
    }, 1000)
  }

  private resetCountdown() {
    this.clearTimer()
    this.countdownSeconds = COUNT + 1
    this.codeText = '获取验证码'
    localStorage.removeItem('surplus_time')
  }

  private clearTimer() {
    if (this.timer) clearInterval(this.timer)
  }
}
